/**
 * Página pública de descarga del APK de la app de terreno (VANTAK Terreno).
 * Vía interina mientras se tramita Google Play (ver docs/PLAN-REEMPLAZO-TAK.md §5/§11).
 * El APK firmado se sirve desde /downloads/vantak-terreno.apk (carpeta public/downloads).
 */
import { useTranslation, Trans } from 'react-i18next'

const APK_URL = '/downloads/vantak-terreno.apk'

export default function DownloadPage() {
    const { t } = useTranslation()
    return (
        <div className="min-h-screen bg-gray-950 text-gray-200 flex items-center justify-center p-6">
            <div className="w-full max-w-lg bg-gray-900/60 border border-white/10 rounded-3xl p-8 shadow-2xl">
                <h1 className="text-2xl font-black text-white">{t('download.title')}</h1>
                <p className="mt-2 text-sm text-gray-400">
                    {t('download.intro')}
                </p>

                <a
                    href={APK_URL}
                    className="mt-8 block w-full text-center bg-blue-600 hover:bg-blue-500 text-white font-bold py-4 rounded-2xl transition-all"
                    download
                >
                    {t('download.downloadApk')}
                </a>

                <div className="mt-8">
                    <h2 className="text-sm font-black uppercase tracking-widest text-gray-500">{t('download.installation')}</h2>
                    <ol className="mt-3 space-y-2 text-sm list-decimal list-inside text-gray-300">
                        <li>{t('download.step1')}</li>
                        <li>
                            <Trans
                                i18nKey="download.step2"
                                defaults="Al abrirlo, Android pedirá permitir <1>“instalar apps de orígenes desconocidos”</1>: acéptalo para este navegador."
                                components={{ 1: <strong /> }}
                            />
                        </li>
                        <li>{t('download.step3')}</li>
                        <li>
                            <Trans
                                i18nKey="download.step4"
                                defaults="<1>Enrólate</1>: escanea el código QR que te entregue tu coordinador (abre la app automáticamente) o pega el token de enrolamiento."
                                components={{ 1: <strong /> }}
                            />
                        </li>
                        <li>
                            <Trans
                                i18nKey="download.step5"
                                defaults="Otorga el permiso de <1>ubicación</1> (incluida “en segundo plano”) para reportar tu posición."
                                components={{ 1: <strong /> }}
                            />
                        </li>
                    </ol>
                </div>

                <p className="mt-8 text-[11px] text-gray-600">
                    {t('download.footer')}
                </p>
            </div>
        </div>
    )
}
